module.exports = __webpack_public_path__ + "static/media/c-sharp-expert.d9fd8046.png";